module.exports = __webpack_public_path__ + "media/images/headerimage-gradient-bc18bc6164a8ca37547accfd75fc30ec.jpg";